let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4xc4u")).then(() => parcelRequire('8BU3q'));